import { useTranslation } from 'react-i18next';
import { RegistryAct } from '../../../types';

interface ActsTabProps {
  acts: RegistryAct[];
}

export default function ActsTab({ acts }: ActsTabProps) {
  const { t } = useTranslation('scriptSummary');

  return (
    <div className="registry-card-grid" style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(360px, 1fr))' }}>
      {acts.map((act) => (
        <div key={act.act_id} className="registry-card" style={{ cursor: 'default' }}>
          <h4 className="registry-card-title">
            {t('acts.label', { id: act.act_id, start: act.start_episode, end: act.end_episode })}
          </h4>

          <div className="registry-card-field">
            <span className="registry-field-label">{t('acts.summary')}</span>
            <p className="registry-field-text">{act.summary}</p>
          </div>

          {act.entry_situation && (
            <div className="registry-card-field">
              <span className="registry-field-label">{t('acts.entrySituation')}</span>
              <p className="registry-field-text">{act.entry_situation}</p>
            </div>
          )}

          {act.exit_situation && (
            <div className="registry-card-field">
              <span className="registry-field-label">{t('acts.exitSituation')}</span>
              <p className="registry-field-text">{act.exit_situation}</p>
            </div>
          )}

          {act.main_characters?.length > 0 && (
            <div className="registry-card-field">
              <span className="registry-field-label">{t('acts.mainCharacters')}</span>
              <div className="registry-tag-row">
                {act.main_characters.map((name) => (
                  <span key={name} className="registry-tag">{name}</span>
                ))}
              </div>
            </div>
          )}

          {act.key_scenes_props?.length > 0 && (
            <div className="registry-card-field">
              <span className="registry-field-label">{t('acts.keyScenesProps')}</span>
              <div className="registry-tag-row">
                {act.key_scenes_props.map((name) => (
                  <span key={name} className="registry-tag registry-tag-info">{name}</span>
                ))}
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
